import type * as FeatureFlags from '../slices/feature-flags-slice';
import { useCapability } from './use-capability';
import { useFeatureFlag } from './use-feature-flag';

export const useSharedStorageApi = (flag: FeatureFlags.FeatureFlag) => {
  const [storageApiCapabilityEnabled] = useCapability('framework:storage-api');
  const [storageFeatureFlagEnabled] = useFeatureFlag(flag);
  return storageApiCapabilityEnabled && storageFeatureFlagEnabled;
};
